import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import { GuidedWorkflow } from "src/routes/projects/change-events/guided/workflows/types";
import { applyInitialConfigurationWorkflow } from "./applyConfiguration/initial/applyInitialConfigurationWorkflow";
import { swapProductWorkflow } from "./swapProductCatalog/swapProductWorkflow";

// Maps a change event workflow to the workflow that drives its steps. `GuidedWorkflow<any>`
// is the single, contained boundary where the per-workflow form shape is erased;
// each definition above keeps its concrete type, and the runner never inspects it.
export const guidedWorkflows: Record<
  ChangeEventWorkflow,
  { workflow: GuidedWorkflow<any>; released: boolean } | undefined
> = {
  [ChangeEventWorkflow.SwapProduct]: { workflow: swapProductWorkflow, released: true },
  [ChangeEventWorkflow.ApplyInitialConfiguration]: { workflow: applyInitialConfigurationWorkflow, released: false },
  [ChangeEventWorkflow.ApplyPartialConfiguration]: undefined,
  [ChangeEventWorkflow.AddOnBookOption]: undefined,
  [ChangeEventWorkflow.ConfigurationTrueUp]: undefined,
  [ChangeEventWorkflow.FullLineCustomOption]: undefined,
};
